<template>

    <div class="full">

        <disconnect-bar></disconnect-bar>

        <mq-layout :mq="['sm', 'md']" class="tab-bar-container">

            <div class="bloc-page" @click="goNewsletters">

                <img :src="menuIcon('newsletters', 'my-actions')" class="menu-icon">

                <p class="menu-text" :class="{ selected: isActive('/newsletters', '/my-actions') }">{{ $t('menu_newsletters') }}</p>

            </div>

            <div class="bloc-page" @click="goStats">

                <img :src="menuIcon('stats')" class="menu-icon">

                <p class="menu-text" :class="{ selected: isActive('/stats') }">{{ $t('menu_statistics') }}</p>

            </div>

            <div class="bloc-page" @click="goSettings">

                <img :src="menuIcon('settings')" class="menu-icon">

                <p class="menu-text" :class="{ selected: isActive('/settings') }">{{ $t('menu_settings') }}</p>

            </div>

        </mq-layout>

    </div>

</template>

<script>

import Tag from '@/modules/tag'

import DisconnectBar from '@/components/DisconnectBar'

export default {

    name: 'tab-bar',

    components: {DisconnectBar},

    methods: {

        menuIcon (page, otherPage) {

            return `/img/icons/tab-bar-${page}-${this.isActive('/' + page, '/' + otherPage) ? 'blue' : 'grey'}.svg`
        },

        isActive: function (page, otherPage) {

            return this.$route.fullPath === page || this.$route.fullPath === otherPage
        },

        goNewsletters () {

            Tag.clickAmplitude(this, 'newsletters')

            this.$router.push({ path: '/newsletters' })

        },

        goStats () {

            Tag.clickAmplitude(this, 'stats')

            this.$router.push({ path: '/stats' })

        },

        goSettings () {

            Tag.clickAmplitude(this, 'settings')

            this.$router.push({ path: '/settings' })

        }

    }

}

</script>

<style scoped lang="scss">

    .tab-bar-container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 55px;
        background-color: $white;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        border-top: 1px solid $border-grey;
    }

    .bloc-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 33%;
    }

    .menu-icon {
        height: 24px;
        width: 24px;
    }

    .menu-text {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.33;
        letter-spacing: 0.4px;
        color: #b0c4d1;
        margin-top: 1px;
    }

    .selected {
        color: $blue;
    }

</style>
